import gql from 'graphql-tag';

import publicAccountFragment from './publicAccountFragment';
import accountCapabilitiesFragment from './accountCapabilitiesFragment';
import accountCountFragment from './accountCountFragment';

// Add fields that do not require user authorization in PublicAccountFragment

export const accountFragment = gql`
  fragment accountFragment on Account {
    effectiveFeatures
    creatorDokkioUserID
    ownerDokkioUserID
    industry
    useCase
    onboardingChatMessage
    origin
    utmSource
    utmMedium
    utmCampaign
    utmTerm
    utmContent
    isOnboardingComplete
    isOverIntegrationItemLimit
    autoCreateDokkioLabelConfidenceThreshold
    accountType
    accountCount {
      ...accountCountFragment
    }
    capabilities {
      ...accountCapabilitiesFragment
    }
    subscriptionPeriodEndsAt
    licensedUserCount
    subscriptionStatus
    activeReferralEndsAt
    initialClusterTopicsAddedAt
    rowCreatedAt
    ...publicAccountFragment
  }
  ${publicAccountFragment}
  ${accountCapabilitiesFragment}
  ${accountCountFragment}
`;
export default accountFragment;
